import { render, staticRenderFns } from "./FailReason.vue?vue&type=template&id=065a048a&scoped=true"
import script from "./FailReason.vue?vue&type=script&lang=js"
export * from "./FailReason.vue?vue&type=script&lang=js"
import style0 from "./FailReason.vue?vue&type=style&index=0&id=065a048a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065a048a",
  null
  
)

export default component.exports